<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import Checkbox from "../../atoms/forms/Checkbox.svelte";
  import { ErrorService } from "../../services/error.service";

  let loading = false;

  let disabledJobDetails = false;
  let disabledFooterTel = false;
  let disabledQandA = false;

  const handleDisabledJobDetails = (event) => {
    disabledJobDetails = !!event.detail.value;
  };

  const handleDisabledFooterTel = (event) => {
    disabledFooterTel = !!event.detail.value;
  };

  const handleDisabledQandA = (event) => {
    disabledQandA = !!event.detail.value;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    client.get("/settings/disabledJobDetails").then(({ data }) => {
      if (!data.disabledJobDetails) {
        return;
      }
      console.log(data);
      disabledJobDetails = data.disabledJobDetails;
    });

    client.get("/settings/disabledFooterTel").then(({ data }) => {
      if (!data.disabledFooterTel) {
        return;
      }
      console.log(data);
      disabledFooterTel = data.disabledFooterTel;
    });

    client.get("/settings/disabledQandA").then(({ data }) => {
      if (!data.disabledQandA) {
        return;
      }
      console.log(data);
      disabledQandA = data.disabledQandA;
    });
  });

  const saveDisabled = async () => {
    const client = ApiService.createClient();
    loading = true;
    const promises = [];

    try {
      promises.push(
        client.post("/settings/disabledJobDetails", {
          value: disabledJobDetails,
        }),
        client.post("/settings/disabledFooterTel", {
          value: disabledFooterTel,
        }),
        client.post("/settings/disabledQandA", {
          value: disabledQandA,
        })
      );

      await Promise.all(promises);
    } catch (e) {
      ErrorService.catch(e);
    } finally {
      loading = false;
    }
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">表示設定</h2>

  <div class="mt-6">
    <Checkbox
      label="求人詳細を表示しない"
      on:click={handleDisabledJobDetails}
      checked={disabledJobDetails}
    />
  </div>

  <div class="mt-6">
    <Checkbox
      label="フッターに電話番号を表示しない"
      on:click={handleDisabledFooterTel}
      checked={disabledFooterTel}
    />
  </div>

  <div class="mt-6">
    <Checkbox
      label="QAページを表示しない"
      on:click={handleDisabledQandA}
      checked={disabledQandA}
    />
  </div>
  <BlueButton rounded klass="mt-4" click={saveDisabled} {loading}>
    更新する
  </BlueButton>
</SectionBoard>
